import 'babel-polyfill';
import fetchAPI from 'utils/fetchAPI';

export const REQUEST_CONTACTS = 'REQUEST_CONTACTS';
export const RECIEVE_CONTACTS = 'RECIEVE_CONTACTS';
export const SORT_CONTACTS_BY_KEY = 'SORT_CONTACTS_BY_KEY';
export const SEARCH_CONTACTS_BY_STRING = 'SEARCH_CONTACTS_BY_STRING';
export const LOAD_CONTACT = 'LOAD_CONTACT';

function requestContacts() {
  return {
    type: REQUEST_CONTACTS,
  };
}

function recieveContacts(contacts) {
  return {
    type: RECIEVE_CONTACTS,
    contacts,
    receivedAt: Date.now(),
  };
}

function fetchContacts() {
  return (dispatch, getState) =>
    new Promise((resolve, reject) => {
      const token = getState().users.token;

      dispatch(requestContacts());

      fetchAPI({
        endpoint: '/users/self/contacts',
        headers: {
          'Accept-Language': getState().i18n.locale,
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      })
        .then(response => {
          if (response.status === 200) return response.json();
          return reject(response.statusText);
        })
        .then(json => {
          dispatch(recieveContacts(json.data));
          resolve(getState().contacts);
        })
        .catch(e => reject(e));
    });
}

function shouldFetchContacts(state) {
  return (
    state.contacts.get('items').size === 0 ||
    state.contacts.get('lastUpdated') === 0
  );
}

export function fetchContactsIfNeeded() {
  return (dispatch, getState) =>
    new Promise((resolve, reject) => {
      if (shouldFetchContacts(getState())) {
        dispatch(fetchContacts()).then(contacts => resolve(contacts));
      } else {
        resolve(getState().contacts);
      }
    });
}

export function sortContactsByKey(sortKey) {
  return {
    type: SORT_CONTACTS_BY_KEY,
    sortKey,
  };
}

export function searchContactsByString(searchString) {
  return {
    type: SEARCH_CONTACTS_BY_STRING,
    searchString,
  };
}

export function loadContact(contactId, fallbackProfile) {
  return {
    type: LOAD_CONTACT,
    contactId,
    fallbackProfile,
  };
}

export function loadProfile(userId) {
  return (dispatch, getState) => {
    if (getState().users.user.id === userId) {
      return dispatch(loadContact(userId, getState().users.user));
    }
    return dispatch(loadContact(userId));
  };
}



// WEBPACK FOOTER //
// ./app/actions/ContactActionCreators.js